import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';
import { MenuService } from '../../core/services/menu.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        <ng-container *ngFor="let item of model; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul> `
})
export class AppMenu implements OnInit {
    menuService = inject(MenuService);
    model: any[] = [];

    async ngOnInit(): Promise<void> {
        var resp = await firstValueFrom(this.menuService.getMenusByRoleId());

        // resp.menus.unshift({
        //     parentMenuNameTh: 'HOME',
        //     parentMenuIcon: 'pi pi-fw pi-home',
        //     childrenMenus: [
        //         {
        //             menuNameTh: 'Dashboard',
        //             menuIcon: 'pi pi-chart-pie',
        //             menuUrl: '',
        //             menuCode: '',
        //             menuNameEn: ''
        //         }
        //     ]
        // });
        resp.menus.forEach((menu) => {
            this.model.push({
                label: menu.parentMenuNameTh,
                icon: menu.parentMenuIcon,
                items: menu.childrenMenus.map((detail) => {
                    return {
                        label: detail.menuNameTh,
                        icon: detail.menuIcon,
                        routerLink: [detail.menuUrl]
                    };
                })
            });
            this.model.push({ separator: true });
        });
    }
}
